import { call, put } from 'redux-saga/effects';
import {
  fetchOrganisationsRequest,
  updateEntityGroupFailure,
  updateEntityGroupSuccess,
} from '../actions';
import { updateEntityGroup } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { UpdateEntityGroupRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnDrawerOff, turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateEntityGroupSaga(action: UpdateEntityGroupRequestAction) {
  try {
    let err: ApiError | null;
    const { groupId, groupData } = action.payload;
    const response: ApiResponse = yield call(updateEntityGroup, groupId, groupData);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(updateEntityGroupSuccess());
    yield put(turnDrawerOff());
    yield put(fetchOrganisationsRequest());
    yield put(
      turnMessageOn({
        title: i18n.t('common.success'),
        description: i18n.t('notifications.saved-successfully'),
        type: MessageStates.SUCCESS,
      } as MessageData)
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateEntityGroupFailure());
  }
}
